export const TASKS_ROUTE_NAME = "/tasks/" as const;
